<div class="modal-content" piqetAngularDraggable>
  <div class="modal-header header-modal">
    <h2 class="modal-title ml-auto pl-5" id="exampleModalLabel">
      <div class="bootstrap-dialog-title" id="dialogMaterialCreate_title">
        {{ modalLabel }}
      </div>
    </h2>

    <button type="button" class="closeModal pull-right" aria-label="Close" (click)="onClose()">
      <img src="./assets/icons/pop-up-cross.svg" width="16" height="17" />
    </button>
  </div>
  <div class="modal-body body-modal">
    <form [formGroup]="teamMemberForm">
      <div class="row">
        <div class="col-sm-12">
          <div class="form-group">
            <label
              *ngIf="teamMemberForm.controls['userName']?.value"
              class="sub-header-drpdown pb-2"
              >User *</label
            >
            <ng-select
              [clearable]="true"
              [clearOnBackspace]="false"
              [items]="userList"
              #select
              [searchable]="false"
              bindLabel="name"
              formControlName="userName"
              [searchFn]="commonInputSearch"
              placeholder="User *"
            >
              <ng-template ng-header-tmp>
                <div class="has-feedback">
                  <input
                    type="text"
                    class="form-control accordion-search search-input"
                    id="inputValidation"
                    (input)="select.filter($any($event.target).value)"
                    placeholder="Search..."
                  />
                  <span class="form-control-feedback">
                    <i class="fa fa-search icon"></i>
                  </span>
                </div>
              </ng-template>
              <ng-template ng-option-tmp let-item="item" let-search="searchTerm">
                <div [ngOptionHighlight]="search" title="{{ item?.name }}">{{ item.name }}</div>
              </ng-template>
            </ng-select>
            <div
              *ngIf="
                (teamMemberForm.controls['userName']?.touched &&
                  teamMemberForm.controls['userName']?.invalid) ||
                ((teamMemberForm.controls['userName']?.touched || submitted) &&
                  teamMemberForm.controls['userName'].value?.name === 'User') ||
                (submitted && !teamMemberForm.controls['userName'].value?.name)
              "
              class="input-error"
            >
              Please select User.
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-12">
          <div class="form-group">
            <label
              *ngIf="teamMemberForm.controls['roleName']?.value"
              class="sub-header-drpdown pb-2"
              >Role name *</label
            >
            <ng-select
              [clearable]="true"
              [clearOnBackspace]="false"
              [items]="roleListNew"
              #roleSelect
              formControlName="roleName"
              [searchable]="false"
              bindLabel="name"
              [searchFn]="commonInputSearch"
              placeholder="Role name *"
            >
              <ng-template ng-header-tmp>
                <div class="has-feedback">
                  <input
                    type="text"
                    class="form-control accordion-search search-input"
                    id="inputValidation"
                    (input)="roleSelect.filter($any($event.target).value)"
                    placeholder="Search..."
                  />
                  <span class="form-control-feedback">
                    <i class="fa fa-search icon"></i>
                  </span>
                </div>
              </ng-template>
              <ng-template ng-option-tmp let-item="item " let-search="searchTerm ">
                <div [ngOptionHighlight]="search" title="{{ item?.name }}">{{ item.name }}</div>
              </ng-template>
            </ng-select>
            <div
              *ngIf="
                (teamMemberForm.controls['roleName']?.touched &&
                  teamMemberForm.controls['roleName']?.invalid) ||
                ((teamMemberForm.controls['roleName']?.touched || submitted) &&
                  teamMemberForm.controls['roleName'].value?.name === 'Role name') ||
                teamMemberForm.controls['roleName'].value?.name === 'Team' ||
                (submitted && !teamMemberForm.controls['roleName'].value?.name)
              "
              class="input-error"
            >
              Please select Role.
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
  <div class="modal-footer">
    <button type="button " class="btn btn-light cancelBtn" (click)="onClose()">Cancel</button>
    <button type="button " class="modelBtn purpleBtnHoverEffect" (click)="onSave()">Save</button>
  </div>
</div>
